import React, { useEffect, useState, createElement } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { Footer } from '../components/Footer';
import { TypeformModal } from '../components/TypeformModal';
export function LandingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  useEffect(() => {
    document.title = 'Lighthouse Capital Group | Done-For-You Business Acquisitions';
    const metaDesc = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDesc.setAttribute('name', 'description');
    metaDesc.setAttribute('content', 'Our institutional buy-side M&A team handles off-market deal sourcing, financial diligence, negotiation, and full acquisition advisory — so you close the right deal at the right price, guaranteed.');
    if (!document.querySelector('meta[name="description"]')) document.head.appendChild(metaDesc);
    const ogTitle = document.querySelector('meta[property="og:title"]') || document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.setAttribute('content', 'Lighthouse Capital Group | Done-For-You Business Acquisitions');
    if (!document.querySelector('meta[property="og:title"]')) document.head.appendChild(ogTitle);
    const ogDesc = document.querySelector('meta[property="og:description"]') || document.createElement('meta');
    ogDesc.setAttribute('property', 'og:description');
    ogDesc.setAttribute('content', 'We source, vet, negotiate and structure profitable business acquisitions completely done for you. For accredited investors with $200k+ ready to deploy.');
    if (!document.querySelector('meta[property="og:description"]')) document.head.appendChild(ogDesc);
  }, []);
  return <div className="min-h-screen bg-white text-gray-900 selection:bg-brand-green selection:text-white" data-id="element-142">
      <Header data-id="element-143" />
      <main data-id="element-144">
        <HeroSection onOpenModal={() => setModalOpen(true)} data-id="element-145" />
      </main>
      <Footer data-id="element-146" />
      <TypeformModal isOpen={modalOpen} onClose={() => setModalOpen(false)} data-id="element-147" />
    </div>;
}